<template>
  <main class="main">
    <div class="main-container">

      <div class="companyinfo">
        <h1 class="infomaintitle">
          {{ $t('home.infomaintitle') }}
        </h1>
        <h3 class="companydiscript">
          {{ $t('home.companydiscript') }}
        </h3>
        <h3 class="companydiscript1">
          {{ $t('home.companydiscript1')}}
        </h3>
        <h3 class="companydiscript2">
          {{  $t('home.companydiscript2') }}
        </h3>
        <h3 class="companydiscript3">
          {{ $t('home.companydiscript3')}}
        </h3>
        <h3 class="companydiscript4">
          {{ $t('home.companydiscript4')}}
        </h3>
      </div>

<section class="brands">
  <div class="brands__container">
    <router-link to="/silimed" class="brand">
      <img src="/img/Silimed-removebg-preview.png" alt="Silimed Logo" />
    </router-link>

    <router-link to="/invo" class="brand">
      <img src="/img/Invo-removebg-preview.png" id="invo" alt="Invo Logo" />
    </router-link>
  </div>
</section>


    <section class="dc-section" id="doctors">
    <div class="dc-container">
      <h2 class="dc-title">{{  $t('home.dc-title') }}</h2>

      <div class="dc-slider">
        
        <button
          class="dc-arrow dc-prev"
          type="button"
          aria-label="Назад"
          @click="scrollLeft()"
          :disabled="page === 0"
        ></button>

        
        <div
          class="dc-viewport"
          ref="viewport"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
          @touchstart="startDrag"
          @touchmove="onDrag"
          @touchend="endDrag"
          >
  
          <ul class="dc-track" ref="track">
            
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/SaidAhmad.jpg" alt="Саидахмад Кобилов" />
              </div>
              <div class="dc-name">{{ $t('home.dc-name')}}<br/></div>
              <a href="https://www.instagram.com/dr.said_kabilov?igsh=MTB6YW9xbWhtYWU4aw%3D%3D" class="dc-btn" target="_blank" rel="noopener noreferrer">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

            
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Umida2.PNG" alt="Бекназарова Умида Баходировна" />
              </div>
              <div class="dc-name1" v-html="$t('home.dc-name1')"></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/doctor_umida_b?igsh=MWlpazI5MWlzNno4dA%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

            
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/AbdulaevDostonjon.jpg" alt="Абдуллаев Достонжон" />
              </div>
              <div class="dc-name2">{{ $t('home.dc-name2')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.abdullaev.d.k?igsh=MWQ1c3hseDB5emhmbQ%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

         
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Gulruh.jpg" alt="Гульрух Маратовна" />
              </div>
              <div class="dc-name3">{{ $t('home.dc-name3')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr_gulruh.maratovna?igsh=MTNqNmYzdjFwOGJtZw%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

            
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Imomiy.png" alt="Имомий Гофур-Арслонбек Улугбекович" />
              </div>
              <div class="dc-name4" v-html="$t('home.dc-name4')"> </div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/doctorgafur?igsh=MW93ZXNsYTJ0bWRscQ%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

                       
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/dilobar.jpg" alt="Дилобар Ишанходжаева" />
              </div>
              <div class="dc-name5">{{ $t('home.dc-name5')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.ishankhojaeva?igsh=MWptaWVra3hrZWF1bQ%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

                     
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Jahongir.jpg" alt="Jakhongir Yuldashev" />
              </div>
              <div class="dc-name6">{{ $t('home.dc-name6')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/doctorjahongir_work?igsh=N3gzYzl6N2ZvdGZ6">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

                     
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Gulruh.jpg" alt="Nilufar Raxmatovna" />
              </div>
              <div class="dc-name7">{{ $t('home.dc-name7')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/nilufar_raxmatovna_?igsh=cXhidWdjd3VhdWlq">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

                      
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/IMG_5911.jpg" alt="Turdiev Jamshid" />
              </div>
              <div class="dc-name8">{{ $t('home.dc-name8')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.jamshid_turdiyev?igsh=MWcwaWZhaWUxMDFr">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

                     
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Kamola.jpg" alt="Kamola Jo’raeva" />
              </div>
              <div class="dc-name9">{{ $t('home.dc-name9')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/mamaplasticuz?igsh=MWNzNmt0dmg2MDRhaw%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/madalimov.png" alt="Абдумутал Камалович Мадалимов" />
              </div>
              <div class="dc-name10" v-html="$t('home.dc-name10')"></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/mammolog_abdumutal_madalimov?igsh=MWllbHpxcjBvM2oyOA%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>
                                 
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/MalikaT.jpg" alt="Малика Тураева" />
              </div>
              <div class="dc-name11">{{ $t('home.dc-name11')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr_malika_turaeva?igsh=MTBlemZmOWw1ajFuMA%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>
                               
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Valijon.jpg" alt="Валижон Номуродов Кобулжонович" />
              </div>
              <div class="dc-name12" v-html="$t('home.dc-name12')"></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.valijonnomurodov?igsh=MWJsYmpvb3d2dzNrdw%3D%3D">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>
                                    
            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/JasurK.jpg" alt="ЖАСУР КАМИЛОВИЧ" />
              </div>
              <div class="dc-name13">{{  $t('home.dc-name13') }}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.jasur_kamilovich?igsh=ZDFrbjl6YWRtMDB0">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/VohidR.jpg" alt="Vokhid Rajabov" />
              </div>
              <div class="dc-name14">{{ $t('home.dc-name14')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/doctorvokhid?igsh=NjNvMDlkemxwbGhx">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/SardorF.jpg" alt="Sardor Fayziev" />
              </div>
              <div class="dc-name15">{{ $t('home.dc-name15')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.sardorfayziev?igsh=djA4a3BmaDhnaG9v">
                 <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/RakhmonovK.png" alt="Rakhmonov Kamol Aminjonovich" />
              </div>
              <div class="dc-name16" v-html="$t('home.dc-name16')"></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.rakhmonov.k?igsh=d251bjMzbzJ0dW5q">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/OtabekX.png" alt="𝗫𝗼𝗷𝗮𝗺𝘂𝗿𝗮𝘁𝗼𝘃 𝗢𝘁𝗮𝗯𝗲𝗸" />
              </div>
              <div class="dc-name17">{{ $t('home.dc-name17')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.otabekxojamuratov?igsh=dm5ydzVna21xNTR1">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/LazizA.png" alt="Лазиз Аълоханов" />
              </div>
              <div class="dc-name18">{{ $t('home.dc-name18')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.lazizalohanov?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/ShermatovA.png" alt="Ахрор Шерматов" />
              </div>
              <div class="dc-name19">{{ $t('home.dc-name19')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/drshermatov?igsh=MWZueHhoa2Nub2gxZg%3D%3D">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/OrifjonT.jpg" alt="Орифжон Тулипов" />
              </div>
              <div class="dc-name20">{{ $t('home.dc-name20')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/doctor_orifjontalipov?igsh=MWFvb3NhdGhpYmI4Nw%3D%3D">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/InoyatovA.jpg" alt="Азизбек Иноятов" />
              </div>
              <div class="dc-name21">{{ $t('home.dc-name21')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/doctor_inoyatov?igsh=MWFzNjRmeG5taWw4ZA%3D%3D">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/IMG_7798.JPG" alt="Феруз Собиржонович" />
              </div>
              <div class="dc-name22">{{  $t('home.dc-name22') }}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.feruz.khusanov?igsh=MTlmY2JiaWJzM3Z1ag%3D%3D">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

             <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/profile.png" alt="Абдуджалил Эркабоев" />
              </div>
          <div class="dc-name23">{{ $t('home.dc-name23') }}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/abdujalil_plasticsurgeon?igsh=YWhrZ3FkdzB5cWV5">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

           <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/RustemA.png" alt="Аметов Рустем" />
              </div>
              <div class="dc-name24">{{ $t('home.dc-name24')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/md_ametov?igsh=MXdxMTI1OHNpa3NldA%3D%3D">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/Gagik.png" alt="Гагик Макян" />
              </div>
              <div class="dc-name25">{{ $t('home.dc-name25')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/gagik_makian?igsh=MXc2emM0Z3J0b3I4dA%3D%3D">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

           <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/DoctorE.jpg" alt="Doctor Erkinlar" />
              </div>
              <div class="dc-name26">{{ $t('home.dc-name26')}}<br /></div>
              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.erkinlar?igsh=cm95N3JkZnRrNHg2">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

            <li class="dc-card">
              <div class="dc-avatar">
                <img src="/img/dr/zuhriddin.jpg" alt="Зухриддин Йигиталиев" />
              </div>
              <div class="dc-name27">{{  $t('home.dc-name27') }}<br /></div>

              <a class="dc-btn" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/zuhriddin_yigitaliyev?igsh=YjRubmxkNzhncHlo">
                  <span>{{ $t('home.dc-btn-line1') }}</span>
                  <span>{{ $t('home.dc-btn-line2') }}</span>
              </a>
            </li>

          </ul>

        </div>

        <button
          class="dc-arrow dc-next"
          type="button"
          aria-label="Вперёд"
          @click="scrollRight()"
          :disabled="page >= pages - 1"
        ></button>
      </div>

      <div class="dc-bottom">
        <div class="progress-bar">
          <div class="progress-bar-fill" :style="{ width: progress + '%' }"></div>
        </div>
      </div>

      <div class="dc-cta">
        <a class="dc-find" href="https://www.instagram.com/silimed_uzbekistan?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">{{  $t('home.dc-find') }}</a>
      </div>
    </div>
  </section>

      <div class="article-container">
        <div class="article-left">
          <img src="/img/articleimg.jpg" alt="Имплант" class="article-image" />
          <div class="article-overlay">
            <a class="artbtn" @click="goToPure">{{ $t('home.artbtn')}}</a>
          </div>
        </div>

        <div class="article-right">
          <h3>{{  $t('home.articl') }}</h3>
          <div class="article-item">
            <p class="date">15.08.2022</p>
            <a href="#">{{ $t('home.advise')}}</a>
            <span class="time">{{ $t('home.time')}}</span>
          </div>
          <div class="article-item">
            <p class="date">25.08.2022</p>
            <a href="#">{{ $t('home.advise1')}}</a>
            <span class="time">{{ $t('home.time')}}</span>
          </div>
        </div>
      </div>

    </div>
  </main>
</template>


<script>
import { useRouter } from 'vue-router'

export default {
  data() {
    return {
      page: 0,
      pages: 0,
      isDragging: false,
      startX: 0,
      scrollLeftPosition: 0,
      progress: 0,
    }
  },

  setup() {
    const router = useRouter()

    function goToPure() {
      router.push("/pure")
    }

    return { goToPure }
  },
  
  mounted() {
    this.calcPages()
    window.addEventListener("resize", this.calcPages)
    this.$refs.viewport.addEventListener("scroll", this.handleScroll)
  },
  
  beforeUnmount() {
    window.removeEventListener("resize", this.calcPages)
    this.$refs.viewport.removeEventListener("scroll", this.handleScroll)
  },
  
  methods: {
    calcPages() {
      const viewport = this.$refs.viewport
      const track = this.$refs.track
      if (viewport && track) {
        this.pages = Math.ceil(track.scrollWidth / viewport.clientWidth)
      }
    },
    
    handleScroll() {
      const viewport = this.$refs.viewport
      if (viewport) {
        const scrollPercent = viewport.scrollLeft / (viewport.scrollWidth - viewport.clientWidth)
        this.progress = Math.min(100, Math.max(0, scrollPercent * 100))
        this.page = Math.round(viewport.scrollLeft / viewport.clientWidth)
      }
    },
    
    scrollLeft() {
      const viewport = this.$refs.viewport
      if (viewport && this.page > 0) {
        this.page--
        viewport.scrollTo({
          left: viewport.clientWidth * this.page,
          behavior: "smooth"
        })
      }
    },
    
    scrollRight() {
      const viewport = this.$refs.viewport
      if (viewport && this.page < this.pages - 1) {
        this.page++
        viewport.scrollTo({
          left: viewport.clientWidth * this.page,
          behavior: "smooth"
        })
      }
    },
    

    startDrag(e) {
      this.isDragging = true
      this.startX = e.pageX || e.touches?.[0].pageX
      this.scrollLeftPosition = this.$refs.viewport.scrollLeft
      this.$refs.viewport.style.scrollBehavior = "auto"
      this.$refs.viewport.classList.add('dragging') 
    },
    
    onDrag(e) {
      if (!this.isDragging) return
      const x = e.pageX || (e.touches && e.touches[0].pageX)
      const walk = (x - this.startX) * 1.2
      this.$refs.viewport.scrollLeft = this.scrollLeftPosition - walk
    },
    
    endDrag() {
      this.isDragging = false
      this.$refs.viewport.style.scrollBehavior = "smooth"
      this.$refs.viewport.classList.remove('dragging') 
      
      const viewport = this.$refs.viewport
      if (viewport) {
        const newPage = Math.round(viewport.scrollLeft / viewport.clientWidth)
        this.page = Math.min(Math.max(0, newPage), this.pages - 1)
        viewport.scrollTo({
          left: viewport.clientWidth * this.page,
          behavior: "smooth"
        })
      }
    }
  }
}
</script>




<style scoped>

:root { 
    --dc-teal:#00a2a5; 
    --dc-text:#333; 
    --dc-muted:#777; 
    --dc-border:#e6e6e6; 
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto";
}





.main {
  padding-top: 200px;
  padding-bottom: 200px;
  display: flex;
}

.main-container {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 100%;
  transition: all 0.4s ease-in-out;
}

.main-block {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 30px auto;
  padding: 0 20px;
  gap: 50px;
}

.main-implants, .main-geli {
  flex: 1;
  position: relative;
  border-radius: 1px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 300px;
  transition: 400ms;
}

.main-implants:hover {
  background: #0fafad;
}

.main-geli:hover {
  background: #0fafad;
}

.main-implants:hover, .main-geli:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.implants-block-text {
  position: absolute;
  top: 90px;
  left: 20px;
  z-index: 2;
  color: #333;
}

.main-implants-span {
  display: block;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #928c8c;
  font-family: Roboto;
}

.main-implants-link {
  display: inline-flex;
  align-items: center;
  padding: 8px 15px;
  background-color: #8e7d7da4;
  color: #0fafad;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500;
  transition: background-color 0.3s ease;
  transition: 400ms;
  font-family: Roboto;
}

.main-implants-link:hover {
  transform: translateY(-5px);
  color: white;
  background-color: #0fafad;
}

.main-implants-link i {
  margin-left: 8px;
  font-size: 12px;
}

.main-implants-img {
  position: absolute;
  right: 0;
  bottom: 20;
  max-height: 80%;
  max-width: 60%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.main-implants:hover .main-implants-img,
.main-geli:hover .main-implants-img {
  transform: scale(1.05);
}

.infomaintitle, .companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {
  transition: font-size 0.4s ease, line-height 0.4s ease, margin 0.4s ease;
}

.companyinfo {
  display: grid;
  justify-content: center;
  align-items: center;
  background-image: url("/public/img/bg1.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  row-gap: 20px;
  width: 100%;
  margin-top: -200px;
  padding: 100px 20px; 
  box-sizing: border-box;
}


.companyinfo h1,
.companyinfo h3 {
  max-width: 1140px; 
  width: 100%; 
  margin: 0 auto;
}


.infomaintitle {
  color: #ffffff;
  font-weight: 100;
  font-size: clamp(20px, 2vw, 36px); 
  font-family: "Roboto Condensed", sans-serif;
  line-height: 1.3;
  text-align: left;
  margin-bottom: 20px;
}


.companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {
  color: #ffffff;
  font-weight: 200;
  font-size: clamp(14px, 1.5vw, 18px);
  font-family: "Roboto Condensed", sans-serif;
  line-height: 1.5;
  text-align: left;
}

@media (max-width: 768px) {
  .companyinfo {
    margin-top: -100px;
    padding: 60px 15px;
    row-gap: 16px;
  }

  .infomaintitle {
    font-size: 20px;
  }

  .companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .companyinfo {
    margin-top: -50px;
    padding: 40px 10px;
    row-gap: 12px;
  }

  .infomaintitle {
    font-size: 18px;
  }

  .companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {
    font-size: 13px;
  }
}








.brands {
  padding: 40px 20px;
  background-color: #f7f7f7;
}

.brands__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.brand {
  width: 500px;
  height: 200px;
  text-align: center;
  transition: transform 0.3s, opacity 0.3s;
}

.brand img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  transition: filter 0.3s;
  cursor: pointer;
}

#invo {
  display: flex;
  width: 200px;
  height: 150px;
  overflow: hidden;
  margin-top: 30px;
}

.brand:hover {
  transform: scale(1.05);
}




.dc-section{
    padding:48px 16px; 
    text-align:center; 
    background:#fff;
    padding-bottom: 100px;
    padding-top: 200px;
}

.dc-container{
    max-width:1180px; 
    margin:0 auto;
}

.dc-title{
    margin:0 0 28px; 
    font-weight:200; 
    font-size:22px; 
    line-height:1.3;
    color: #555555;
}

.dc-slider{
    position:relative; 
    display:flex; 
    align-items:center; 
    gap:8px;
}

.dc-viewport{
    overflow:hidden; 
    flex:1; 
    scroll-behavior:smooth;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    touch-action: pan-y;
    cursor: grab;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.dc-viewport::-webkit-scrollbar {
  display: none;
}

.dc-track{
    display:flex; 
    gap:22px; 
    padding:2px; 
    margin:0; 
    list-style:none;
    transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.dc-card{
  flex: 0 0 280px;
  border:1px solid var(--dc-border);
  border-radius:6px;
  padding:22px 18px 18px;
  background:#fff;
  text-align:center;
  margin: 0 15px;
  padding: 36px 15px 32px;
  transition: .2s linear;
  text-align: center;
  border: 1px solid #ececec;
  border-radius: 3px;
  height: 450px;
  display: grid;
  row-gap: 30px;
  user-select: none;
  scroll-snap-align: start; 
  min-width: 0; 
}

.dc-card:hover{
  border-color: white;
  background: white;
  box-shadow: 0px 10px 50px rgba(85,85,85, .09);
}

.dc-avatar{
    width:116px; 
    height:116px; 
    margin:0 auto 14px;
}

.dc-avatar img{
    width:100%; 
    height:100%; 
    object-fit:cover; 
    border-radius:50%; 
    display:block;
}

.dc-name, .dc-name1, .dc-name2, .dc-name3, .dc-name4, .dc-name5, .dc-name6, .dc-name7, .dc-name8, .dc-name9, .dc-name10, .dc-name11, .dc-name12, .dc-name13, .dc-name14, .dc-name15, .dc-name16, .dc-name17, .dc-name18, .dc-name19, .dc-name20, .dc-name21, .dc-name22, .dc-name23, .dc-name24, .dc-name25, .dc-name26, .dc-name27 {
    font-weight:500; 
    font-size:16px; 
    line-height:1.35; 
    color:#00a2a5; 
    margin-bottom:8px;
    height: auto; 
    min-height: 44px; 
    display: flex;
    align-items: center;
    justify-content: center;
}

.dc-clinic{
    font-size:14px; 
    line-height:1.45; 
    color:#555; 
    min-height:40px; 
    margin-bottom:16px;
}

.dc-btn{
  display:flex; 
  align-items:stretch;
  justify-content: center;
  padding-bottom: 10px;
  text-decoration:none; 
  text-transform:uppercase; 
  letter-spacing:.02em;
  font-size:12px; 
  line-height:1.15; 
  color:var(--dc-text);
  border:1px solid #cfcfcf; 
  border-radius:2px; 
  transition:border-color .25s,color .25s;
  background: #00a2a5;
  color: #fff;
  transition: 300ms;
  height: 50px;
  width: 100%;
  flex-direction: column;
  justify-content: center;
}

.dc-btn:hover{
    color:#00a2a5; 
    border-color:#00a2a5;
    background: white;
}



.dc-arrow{
  flex:0 0 36px; 
  height:36px; 
  border:1px solid #dcdcdc; 
  border-radius:50%;
  background:#fff; 
  cursor:pointer; 
  position:relative; 
  transition:border-color .25s, box-shadow .25s;
  z-index: 10; 
}

.dc-arrow::before{
  content:""; 
  position:absolute; 
  inset:0; 
  margin:auto; 
  width:8px; 
  height:8px;
  border-top:2px solid #9b9b9b; 
  border-right:2px solid #9b9b9b; 
  transform:rotate(45deg);
}

.dc-prev::before{ 
    transform:rotate(225deg); 
    left:2px; 
}

.dc-next::before{ 
    transform:rotate(45deg); 
    right:2px; 
}

.dc-arrow:hover{
    border-color:var(--dc-teal); 
    box-shadow:0 0 0 2px rgba(0,162,165,.08);
}

.dc-bottom{
    display:flex; 
    align-items:center;
    gap:14px; 
    margin:18px 0 0;
}


.progress-bar {
  width: 100%;
  height: 4px;
  background: #ddd;
  margin-top: 12px;
  border-radius: 2px;
  overflow: hidden;
}
.progress-bar-fill {
  height: 100%;
  background: #00a2a5;
  transition: width 0.2s linear;
  border-radius: 2px;
  width: 0%;
}


.dc-cta{
    margin-top:24px;
}

.dc-find{
  display:inline-block; 
  text-decoration:none; 
  text-transform:uppercase; 
  letter-spacing:.02em;
  font-size:12px; 
  color:var(--dc-teal); 
  border:1px solid #00a2a5; 
  padding:12px 18px; 
  border-radius:2px;
  transition:color .25s, background .25s;
}

.dc-find:hover{
    background:#00a2a5; 
    color:#fff;
}

.dc-viewport.dragging {
    scroll-behavior: auto;
    cursor: grabbing;
}

.dc-viewport.dragging .dc-track {
    transition: none;
}


@media (max-width: 768px) {
    .dc-card {
        flex: 0 0 240px; 
        margin: 0 10px;
    }
}




@media (min-width: 2000px) {
  .dc-card { flex: 0 0 25%; } 
}
@media (max-width: 1440px) {
  .dc-card { flex: 0 0 33.333%; } 
}
@media (max-width: 1024px) {
  .dc-card { flex: 0 0 50%; } 
}
@media (max-width: 600px) {
  .dc-card { flex: 0 0 100%; }
}



.article-container {
  display: flex;
  background: #fff;
  width: 1140px;
  padding: 20px;
  gap: 40px;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap; 
  margin-left: 400px;
  padding-top: 100px;
}

.article-left {
  position: relative;
  flex: 1;
  min-width: 300px;
  max-width: 600px;
}

.article-image {
  width: 100%;
  height: auto;
  border-radius: 10px;
  display: block;
  object-fit: cover;
}

.article-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0; 
  background: rgba(0, 128, 128, 0.8);
  color: #fff;
  padding: 15px;
  border-radius: 0 0 10px 10px;
  text-align: center;
}

.article-overlay h2 {
  margin: 0 0 10px;
  font-size: 18px;
  width: 100%;
}

.artbtn {
  display: inline-block;
  background: transparent;
  border: 1px solid #fff;
  padding: 8px 15px;
  color: #fff;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}

.artbtn:hover {
  background: #fff;
  color: teal;
}

.article-right {
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.article-right h3 {
  margin-bottom: 20px;
  font-size: 22px;
  width: 100%;
}

.article-item {
  margin-bottom: 20px;
}

.article-item .date {
  font-size: 14px;
  color: #777;
  margin: 0;
}

.article-item a {
  display: block;
  font-size: 16px;
  color: #000;
  text-decoration: none;
  margin: 5px 0;
  transition: 0.3s;
}

.article-item a:hover {
  color: teal;
}

.article-item .time {
  font-size: 14px;
  color: #555;
}

.more-link {
  color: teal;
  font-weight: bold;
  text-decoration: none;
  margin-top: 20px;
  display: inline-block;
}


/* адаптив */
@media (max-width: 1024px){
  .dc-card{flex:0 0 calc((100% - 22px)/2);}
}
@media (max-width: 640px){
  .dc-title{font-size:18px;}
  .dc-card{flex:0 0 100%;}
  .dc-arrow{display:none;} 
}


@media (max-width: 768px) {
  .main-block {
    flex-direction: column;
  }
  
  .main-implants, .main-geli {
    margin-bottom: 20px;
  }
  
  .main-implants-span {
    font-size: 20px;
  }
}

@media (min-width: 1920px) {
  .main { padding-bottom: 220px; }
  .main-block { max-width: 1400px; gap: 64px; }
  .dc-container { max-width: 1400px; }
  .dc-card { height: 520px; }
  .article-container { width: 1280px; }
}

/* Large desktops (1440px–1919px) */
@media (min-width: 1440px) and (max-width: 1919px) {
  .hero { height: 500px; }
  .main-block { max-width: 1280px; gap: 56px; }
  .dc-container { max-width: 1280px; }
  .article-container { width: 1200px; margin-left: auto; margin-right: auto; }
}

/* Desktops / small laptops (1200px–1439px) */
@media (min-width: 1200px) and (max-width: 1439px) {
  .main-block { max-width: 1140px; gap: 40px; padding: 0 16px; }
  .hero { height: 460px; }
  .article-container { width: 1100px; margin-left: auto; margin-right: auto; }
}

/* Tablets landscape (1024px–1199px) */
@media (min-width: 1024px) and (max-width: 1199px) {
  .main-nav { padding: 16px 32px; }
  .nav { gap: 24px; }
  .hero { height: 420px; }
  .hero-content { gap: 32px; }
  .main-block { max-width: 980px; gap: 32px; padding: 0 16px; }
  .implants-block-text { top: 70px; }
  .article-container { width: 960px; margin-left: auto; margin-right: auto; }
  /* Doctors: 3 per row */
  .dc-card { flex: 0 0 calc((100% - 44px)/3); margin: 0 8px; }
}

/* Tablets portrait (768px–1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .top-bar-right { gap: 20px; }
  .nav { gap: 16px; }
  .hero { height: 380px; }
  .hero-content { flex-direction: column; gap: 16px; padding: 0 16px; text-align: center; }
  .hero-img img { max-width: 80%; height: auto; display: block; margin: 0 auto; }
  .main { padding-top: 160px; padding-bottom: 160px; }
  .main-block { max-width: 740px; gap: 24px; padding: 0 16px; }
  .main-implants, .main-geli { min-height: 260px; }
  .implants-block-text { top: 48px; left: 16px; }
  .companyinfo { height: auto; background-attachment: scroll; padding: 60px 24px; margin-top: -120px; }
  .companyinfo h1, .companyinfo h3 { width: 100%; }
  .brands__container { gap: 60px; }
  .brand { width: 360px; height: 160px; }
  .dc-card { flex: 0 0 calc((100% - 22px)/2); margin: 0 6px; height: 420px; }
  .dc-arrow { display: none; }
  .article-container { width: 100%; margin: 0 auto; padding: 20px; }
  .article-left, .article-right { max-width: 100%; }
}

@media (min-width: 576px) and (max-width: 767px) {
  .top-bar-left { display: none; } 
  .hero { height: 340px; }
  .hero-text h2 { font-size: 1.6rem; }
  .hero-text p { font-size: 1.4rem; }
  .main { padding-top: 120px; padding-bottom: 120px; }
  .main-block { flex-direction: column; gap: 16px; padding: 0 12px; }
  .companyinfo { padding: 48px 16px; margin-top: -100px; }
  .brand { width: 300px; height: 140px; row-gap: 40px;}
  .dc-card { flex: 0 0 calc((100% - 22px)/2); height: 400px; }
  .article-container { flex-direction: column; gap: 20px; margin: 0 auto; width: 100%; padding: 16px; }
}


@media (max-width: 575px) {
  .logo img { height: 40px; width: 40px; }
  .top-bar-left { display: none; } 
  .top-bar-right { gap: 16px; }
  .nav { position: static; }
  .dropdown { left: 0; right: 0; min-width: unset; }
  .hero { height: 300px; }
  .hero-content { flex-direction: column; gap: 12px; padding: 0 12px; }
  .hero-text h2 { font-size: 1.4rem; }
  .hero-text p { font-size: 1.2rem; }
  .main { padding-top: 100px; padding-bottom: 100px; }
  .main-block { flex-direction: column; gap: 14px; padding: 0 12px; }
  .main-implants, .main-geli { min-height: 240px; }
  .implants-block-text { top: 36px; left: 12px; }
  .companyinfo { padding: 36px 12px; margin-top: -80px; }
  .brands__container { row-gap: 40px; }
  .brand { width: 260px; height: 120px; display: block; align-items: center; justify-content: center;}
  .dc-card { flex: 0 0 100%; height: 380px; margin: 0; }
  .article-container { flex-direction: column; gap: 16px; width: 100%; margin: 0 auto; padding: 12px; }
  .article-right h3 { font-size: 20px; }
  .article-item a { font-size: 15px; }
}

@media (max-width: 380px) {
  .hero { height: 260px; }
  .hero-text h2 { font-size: 1.2rem; }
  .hero-text p { font-size: 1.05rem; }
  .dc-card { height: 360px; }
  .article-right h3 { font-size: 18px; }
}

@media (max-width: 1280px) {
  .article-container { margin-left: auto !important; margin-right: auto !important; }
}

@media (max-width: 991px) {
  .hero {
    height: 350px;
  }
  
  .hero-content {
    padding: 0 20px;
  }
  
  .hero-img img {
    max-width: 80%;
    height: auto;
  }
  
  .main {
    padding-top: 100px;
    padding-bottom: 100px;
  }
  
  .brand {
    width: 100%;
    max-width: 400px;
  }
  
  .dc-section {
    padding-top: 100px;
    padding-bottom: 60px;
  }
  
  .dc-card {
    flex: 0 0 calc((100% - 22px)/2);
    height: auto;
    min-height: 400px;
  }
  
  .article-container {
    padding-top: 60px;
  }
}

@media (max-width: 767px) {
  .header_top-bar {
    font-size: 12px;
  }
  
  .nav {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
  
  .hero {
    height: 300px;
  }
  
  .hero-text h2 {
    font-size: 1.5rem;
  }
  
  .hero-text p {
    font-size: 1.2rem;
  }
  
  .stripes div {
    animation-delay: 0s !important;
    animation-duration: 0.3s;
  }
  
  .companyinfo {
    padding: 40px 15px;
  }
  
  .infomaintitle {
    font-size: 20px;
  }
  
  .companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {
    font-size: 14px;
  }
  
  .brands {
    padding: 20px 15px;
  }
  
  .brand {
    height: 150px;
    width: 260px; height: 120px; display: block; align-items: center; justify-content: center;
  }
  
  #invo {
    width: 150px;
    height: 120px;
    margin-top: 15px;
  }
  
  .dc-title {
    font-size: 18px;
  }
  
  .dc-card {
    flex: 0 0 100%; /* 1 карточка в ряд */
    margin: 0 10px;
  }
  
  .dc-arrow {
    display: none; /* Скрываем стрелки на мобильных */
  }
  
  .article-overlay h2 {
    font-size: 16px;
  }
  
  .artbtn {
    font-size: 14px;
    padding: 6px 12px;
  }
  
  .article-right h3 {
    font-size: 20px;
  }
}

@media (max-width: 575px) {
  .header-phone, .header-mail, .header-cer {
    font-size: 11px;
    padding-left: 18px;
  }
  
  .hero {
    height: 250px;
  }
  
  .hero-text h2 {
    font-size: 1.2rem;
  }
  
  .hero-text p {
    font-size: 1rem;
  }
  
  .main {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  
  .companyinfo {
    padding: 30px 10px;
  }
  
  .infomaintitle {
    font-size: 18px;
  }
  
  .companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {
    font-size: 13px;
  }
  
  .brand {
    height: 120px;
    width: 260px; height: 120px; display: block; align-items: center; justify-content: center;
  }
  
  #invo {
    width: 120px;
    height: 100px;
    margin-top: 10px;
  }
  
  .dc-section {
    padding: 30px 10px;
  }
  
  .dc-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
  
  .dc-name, .dc-name1, .dc-name2, .dc-name3, .dc-name4, .dc-name5, .dc-name6, .dc-name7, .dc-name8, .dc-name9, .dc-name10, .dc-name11, .dc-name12, .dc-name13, .dc-name14, .dc-name15, .dc-name16, .dc-name17, .dc-name18, .dc-name19, .dc-name20, .dc-name21, .dc-name22, .dc-name23, .dc-name24, .dc-name25, .dc-name26, .dc-name27 {
    font-size: 14px;
  }
  
  .dc-btn {
    font-size: 11px;
    padding: 8px 12px;
    height: 40px;
  }
  
  .article-container {
    padding: 20px 10px;
    gap: 20px;
  }
  
  .article-overlay {
    padding: 10px;
  }
  
  .article-overlay h2 {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .artbtn {
    font-size: 12px;
    padding: 5px 10px;
  }
  
  .article-right h3 {
    font-size: 18px;
  }
  
  .article-item .date {
    font-size: 12px;
  }
  
  .article-item a {
    font-size: 14px;
  }
  
  .article-item .time {
    font-size: 12px;
  }
  
}

/* Очень маленькие мобильные (до 360px) */
@media (max-width: 360px) {
  .hero-text h2 {font-size: 1rem;}
  .hero-text p {font-size: 0.9rem;}
  .infomaintitle {font-size: 16px;}
  .companydiscript, .companydiscript1, .companydiscript2, .companydiscript3, .companydiscript4 {font-size: 12px;}
  .dc-title {font-size: 15px;}
  .article-right h3 {font-size: 16px;}
}
</style>